module.exports = {
    TOASTR_ERROR: 'TOASTR_ERROR',
    TOASTR_SUCCESS: 'TOASTR_SUCCESS',
    TOASTR_WARNING: 'TOASTR_WARNING',
    TOASTR_INFO: 'TOASTR_INFO',
}
